angular.module('tasks.meeting-attendance')
    .component('taskMeetingAttendanceBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '='
        },
        templateUrl: 'app/task/meeting-attendance/_btn-options.html',
        controller: function (TaskMeetingAttendanceService) {
            this.TaskMeetingAttendanceService = TaskMeetingAttendanceService;
        }
    })
